export default __webpack_public_path__ + "static/media/recon.7d858c62.webp";